import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { preloadApi } from '../../api/preload';
import { CardType, LogType, TagType, UserType } from '../../types';
import { useUser } from '../../hooks/useUser';

type PreloadDataType = {
  cards: CardType[];
  tags: TagType[];
  logs: LogType[];
  users: UserType[];
}

type PreloadStateType = {
  data: PreloadDataType | null;
  loading: boolean;
  error: string | null;
}

const initialState: PreloadStateType = {
  data: null,
  loading: false,
  error: null,
};

// Async thunk to fetch preload data
export const fetchPreload = createAsyncThunk<
  PreloadDataType, // Return type
  void, // Argument type
  { state: RootState }
>(
  'preload/fetchPreload',
  async (_, thunkAPI) => { // _ is payload, not used
    const user = thunkAPI.getState().user.data;

    const externalUserKey = user?.userKey || 7;
    const userToken = user?.userToken || "7e16b5527c77ea58";
    const companyKey = user?.companyKey || 2;
    const companyApiKey = "09df728269";

    try {
      const response = await preloadApi.getPreload({ externalUserKey, userToken, companyKey, companyApiKey });
      return response.data;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.response?.data || 'Error fetching data');
    }
  }
);

// Preload slice
const preloadSlice = createSlice({
  name: 'preload',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchPreload.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchPreload.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchPreload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
  },
});

export default preloadSlice.reducer;
